import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { RowNode } from 'ag-grid-community';
import { BsModalService } from 'ngx-bootstrap/modal';
import { environment } from '../../../../../../../environments/environment';
import { paths } from '../../../../../../app-routing.module';
import { LanguageService } from '../../../../../../core/services/language.service';
import { MessageModalComponent } from '../../../../../../shared/components/message-modal/message-modal.component';
import { GoogleAnalyticsCategories, GoogleAnalyticsService } from '../../../../../../shared/services/google-analytics.service';
import { ConditionValue } from '../../../../../../shared/sub-modules/user-views/components/conditions/condition/condition-value';
import { SearchDropdownContainerComponent } from '../../../../components/search-dropdown-container/search-dropdown-container.component';
import { ImportStatus } from '../../../../enums/importation-status';
import { Importation } from '../../../../models/importation';
import { BaseComponent } from '../../../../../../shared/components/base-component';
import { UserViewComponent } from '../../../../../../shared/sub-modules/user-views/components/user-view/user-view.component';
import { UserViewMetadata } from '../../../../../../shared/sub-modules/user-views/models/user-view-metadata';

/** Detalles de la ruta */
export const detailsRoute = {
  es: { path: 'Detalles', title: 'Detalles de la importación' },
  en: { path: 'Details', title: 'Details of import' },
  pt: { path: 'Detalhes', title: 'Detalhes da importação' },
  role: 'RE',
};

@Component({
  selector: 'app-historical-imports',
  templateUrl: './historical-imports.component.html',
  styleUrls: ['./historical-imports.component.css'],
})
export class HistoricalImportsComponent
  extends BaseComponent
  implements OnInit {
  constructor(
    private cdr: ChangeDetectorRef,
    private modalService: BsModalService,
    private langService: LanguageService,
    private gaService: GoogleAnalyticsService,
  ) {
    super();
    const language = this.langService.getCurrentLanguage();
    this.routeImportPickups = '/' + paths.ImportPickups[language].path;
  }

  /** Variable para utilizar el componente de búsqueda */
  @ViewChild(UserViewComponent, { static: true }) viewComponent: UserViewComponent;

  /** Obtiene la metadata de la API */
  get metadata(): UserViewMetadata {
    return this.viewComponent.metadata;
  }

  /** Almacena la ruta de importar una recogida */
  routeImportPickups: string;

  /** Componente con los filtros secundarios */
  SearchDropdownContainerComponent =
    SearchDropdownContainerComponent;

  /** Almacena las situaciones de importación de la recogida para mostrar en el desplegable de búsqueda */
  importStatus: Array<ConditionValue>;

  /** Para saber que ya se ha loaded el contenido */
  loaded = false;

  ngOnInit() {
    this.addSubscription(
      this.viewComponent.initialized.subscribe(
        this.searchInitialization.bind(this)
      )
    );
  }

  searchInitialization() {
    const search = this.viewComponent;
    search.actionCell('ImportNumber', {
      action: this.clickImportationNumber,
    });
    let index = -1;
    this.importStatus = Object.getOwnPropertyNames(
      search.metadata.Search.Properties.ImportStatus.Options
    ).map((name) => {
      index++
      return {
        text:
        search.metadata.Search.Properties.ImportStatus
            .Options[name],
        value: index,
      };
    });
    this.addSubscription(
      this.viewComponent.grid.firstDataRendered.subscribe(() => {
        this.viewComponent.grid.api.autoSizeAllColumns();
        this.cdr.detectChanges();
        this.loaded = true;
      })
    );
    this.cdr.detectChanges();
  }

  clickImportationNumber(importation: Importation, row: RowNode) {
    if (importation.ImportStatus === ImportStatus.InProgress) {
      this.modalService.show(MessageModalComponent, {
        initialState: {
          message: this.langService.instant('PICKUPS.IMPORT_IN_PROCESS'),
          closeText: this.langService.instant('SHARED.ACCEPT'),
        },
      });
      return;
    }
    row.setSelected(true);
    setTimeout(() => {
      this.viewComponent.getState();
      const params = [
        detailsRoute[this.langService.getCurrentLanguage()].path,
        this.routeNumber(importation),
      ];
      this.viewComponent.navigateWithState(params)
    }, 50);
  }

  private routeNumber(importation: Importation): any {
    return importation.ImportNumber;
  }
  clickImport() {
    this.gaService.sendGoogleAnalyticsEvent(
      GoogleAnalyticsCategories.Otros,
      'Ir a Importar Recogidas'
    );
  }
  clickTemplate() {
    this.gaService.sendGoogleAnalyticsEvent(
      GoogleAnalyticsCategories.Otros,
      'Descarga Plantilla Importar Recogidas'
    );
  }
}
